import { useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Header } from "./Header";
import { MessageList } from "./MessageList";
import { MessageInput } from "./MessageInput";
import { AppState } from "../store/definitions";
import { ConversationEnded } from "./ConversationEnded";
import { NotificationBar } from "./NotificationBar";
import { removeNotification } from "../store/actions/genericActions";
import { notifications } from "../notifications";
import { AttachFileDropArea } from "./AttachFileDropArea";
import { deveMostrarCsatNoAtendimento, isConversationEnded } from "../store/selectors";
import { CsatCard } from "./CsatCard";

export const MessagingCanvasPhase = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(removeNotification(notifications.failedToInitSessionNotification("ds").id));
    }, [dispatch]);

    /*
     * Despedida (ConversationEnded): a regra mora no selector `isConversationEnded`, que é a MESMA
     * lida pelo `MessageBubble` para desabilitar os quick-replies. Antes ela era calculada inline
     * aqui; virou selector em 2026-09-03 para não existir em duas cópias (ver o comentário lá).
     */
    const conversationEnded = useSelector((state: AppState) => isConversationEnded(state.chat));

    /*
     * Pesquisa disparada pela macro do atendente, no meio do atendimento (2026-09-12).
     *
     * Até aqui avaliar e conversar eram mutuamente exclusivos por CONSTRUÇÃO — o card só existia no
     * galho que SUBSTITUI o composer. Agora os dois coexistem: a faixa entra ACIMA do composer, que
     * continua montado e capaz de enviar. A pesquisa não pode custar ao apostador a capacidade de
     * continuar falando com quem está do outro lado.
     */
    const csatNoAtendimento = useSelector((state: AppState) => deveMostrarCsatNoAtendimento(state.chat));

    const Wrapper = conversationEnded ? Fragment : AttachFileDropArea;

    return (
        <Wrapper>
            <Header />
            <NotificationBar />
            <MessageList />
            {conversationEnded ? (
                <ConversationEnded />
            ) : (
                <>
                    {csatNoAtendimento && <CsatCard variante="atendimento" />}
                    <MessageInput />
                </>
            )}
        </Wrapper>
    );
};
